import React, { useCallback, useEffect, useState } from 'react';
import api from '../../../services/api';
import { moeda } from '../../../components/funcoes';
import { Container as ContainerSuite, Table } from 'rsuite';
import { Container, ContainerInfo } from '../styles';
import { useAuth } from '../../../hooks/auth';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { ContentHeader } from '../../../components/ContentHeader';
import { CustomHeaderCell } from '../../../components/CustomHeaderCell';
import { CustomCell } from '../../../components/CustomCell';
import { RelatorioFiltroPeriodo } from '../../../components/RelatorioFiltroPeriodo';

const { Column } = Table;

const RelatorioVendas = () => {
  const { id_empresa } = useAuth();
  const [vendas, setVendas] = useState([]);
  const [dataInicio, setDataInicio] = useState(null);
  const [dataFim, setDataFim] = useState(null);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [qtdTotal, setQtdTotal] = useState(0);
  const { theme } = useCustomTheme();

  const filtrar = useCallback(async () => {
    setLoading(true);
    let inicial = null,
      final = null;
    if (dataInicio && dataFim) {
      inicial = dataInicio;
      final = dataFim;
    } else {
      let data = new Date();
      let primeiroDia = new Date(data.getFullYear(), data.getMonth(), 1);
      let ultimoDia = new Date(data.getFullYear(), data.getMonth() + 1, 0);
      inicial =
        primeiroDia.getFullYear() +
        '-' +
        ('00' + (primeiroDia.getMonth() + 1)).slice(-2) +
        '-' +
        ('00' + primeiroDia.getDate()).slice(-2);
      final =
        ultimoDia.getFullYear() +
        '-' +
        ('00' + (ultimoDia.getMonth() + 1)).slice(-2) +
        '-' +
        ('00' + ultimoDia.getDate()).slice(-2);
    }
    setDataInicio(inicial);
    setDataFim(final);
    await api
      .post('pedido/relatorioVendas', {
        IdEmpresa: id_empresa,
        DataInicial: inicial,
        DataFinal: final,
      })
      .then((res) => {
        if (res.data.length > 0) {
          setVendas(res.data);
          let totalEntrega = res.data.reduce(
            (sum, li) => sum + Number(li.Valor),
            0,
          );
          let qtdTotal = res.data.reduce(
            (sum, li) => sum + parseFloat(li.QuantidadeVendida),
            0,
          );
          setTotal(totalEntrega);
          setQtdTotal(qtdTotal);
        } else {
          setTotal(0);
          setQtdTotal(0);
          setVendas([]);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dataFim, dataInicio, id_empresa]);

  const imprimir = () => {
    const relatorio = { vendas, qtdVendida: qtdTotal, total };
    localStorage.setItem('relatorio', JSON.stringify(relatorio));
    window.open(
      `/g_imprimir_relatorio_vendas/`,
      'Relatorio',
      'height=800,width=950',
    );
  };

  useEffect(() => {
    filtrar();
  }, [filtrar]);

  return (
    <ContainerSuite
      style={{
        padding: '10px',
        height: 'calc(100vh - 60px)',
        backgroundColor: theme.colors.background,
      }}
    >
      <ContentHeader
        title="Relatório de Vendas"
        thirdComponent={
          <RelatorioFiltroPeriodo
            dataInicio={dataInicio}
            dataFim={dataFim}
            onChangeDataInicio={setDataInicio}
            onChangeDataFim={setDataFim}
            onImprimir={imprimir}
          />
        }
      />

      <Container>
        <ContainerInfo style={{ color: theme.colors.text }}>
          <text>Total de vendas: {qtdTotal}</text>
        </ContainerInfo>
        <ContainerInfo style={{ color: theme.colors.text }}>
          <text>Valor total de vendas: {moeda(total)}</text>
        </ContainerInfo>
      </Container>
      <Table
        height={window.innerHeight - 200}
        data={vendas}
        bordered={true}
        loading={loading}
        style={{
          overflowY: 'auto',
          borderColor: theme.colors.backgroundSecondary,
          backgroundColor: theme.colors.backgroundSecondary,
          color: theme.colors.textSecondary,
        }}
        locale={{
          emptyMessage: 'dados não encontrados',
          loading: 'Carregando...',
        }}
      >
        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
          fixed
        >
          <CustomHeaderCell>IdProduto</CustomHeaderCell>
          <CustomCell dataKey="IdProduto" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Descrição</CustomHeaderCell>
          <CustomCell dataKey="Descricao" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Qtd. Vendida</CustomHeaderCell>
          <CustomCell>{(rowData) => <text>{+(rowData.QuantidadeVendida)}</text>}</CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
        >
          <CustomHeaderCell>Valor</CustomHeaderCell>
          <CustomCell>
            {(rowData) => <text>{moeda(rowData.Valor)}</text>}
          </CustomCell>
        </Column>
      </Table>
    </ContainerSuite>
  );
};

export default RelatorioVendas;
